import { useState } from 'react'

export function useThreadsSearchPreview({ threads, onSelectThread, onClose }) {
  const [previewId, setPreviewId] = useState(null)
  const previewThread = threads.find((thread) => thread.id === previewId) ?? null
  const openThread = (thread) => {
    onSelectThread?.(thread)
    onClose()
  }
  const selectThread = (thread) => {
    if (previewId === thread.id) {
      openThread(thread)
      return
    }
    setPreviewId(thread.id)
  }
  return { previewThread, selectThread, openThread }
}
